export default __webpack_public_path__ + "static/media/slide-3.36b832b4.jpg";